import React from 'react'
import { styled } from '@mui/material/styles'
import TextField, { TextFieldProps } from '@mui/material/TextField'
import { ui } from '../../../utils/uiTokens'

// Тот же вид, что у фильтров: белое поле с тонкой рамкой, розовая на фокусе
const CssTextField = styled(TextField)({
    '.MuiOutlinedInput-notchedOutline': {
        borderColor: ui.border,
    },
    '.MuiInputBase-root': {
        backgroundColor: ui.card,
        borderRadius: ui.radius,
    },
    '.MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: ui.pink,
    },
    '.MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: ui.pink,
    },
})

export default function CustomInput(props: TextFieldProps) {
    return (
        <CssTextField
            margin="normal"
            {...props}
        />
    )
}
